
import { MySwal } from "App";
import { getContext } from "./WebService";


export function changeColor() {
  if (getContext() === "santander") {
    return '#cc0000'
  } else {
    return '#0d1063'
    // return '#0275d8'
  }

}

export function changeAlternativeColor() {
  if (getContext() === "santander") {
    return '#cc0000'
  } else {
    return 'rgb(13, 37, 99, 0.5)'
  }

}

export function isEquals(compare, compared) {
  return JSON.stringify(compare) === JSON.stringify(compared)
}

export function utf8ToB64(str) {
  return window.btoa(str);
}

export function toBase64(file) {
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      let baseURL = reader.result;
      resolve(baseURL);
    };
  });
};

export function successAlert(message, hideAlert) {
  MySwal.fire({
    title: "Sucesso!",
    html: message,
    icon: 'success',
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn-primary "
    }
  }).then(hideAlert);

};

export function infoWarning(message, hideAlert) {
  MySwal.fire({
    title: "Atenção",
    html: message,
    icon: 'info',
    allowOutsideClick: false,
  }).then(hideAlert);
}

export function warningAlert(message, hideAlert) {
  MySwal.fire({
    title: "Atenção!",
    html: message,
    icon: 'warning',
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn-warning"
    }
  }).then(hideAlert);
}

export function infoAlert(message, hideAlert) {
  MySwal.fire({
    title: "Solicitação recebida com sucesso!",
    html: message,
    icon: 'info',
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn-info"
    }
  }).then(hideAlert);
};

export function infoAviso(message, onConfirm, onCancel) {
  MySwal.fire({
    title: "Atenção",
    html: message,
    icon: 'info',
    allowOutsideClick: false,
    showCancelButton: true,
    confirmButtonText: "Sim",
    cancelButtonText: "Não",
    customClass: {
      confirmButton: "btn-info",
      cancelButton: "btn-danger"
    }
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    } else if (result.dismiss === MySwal.DismissReason.cancel && onCancel) {
      onCancel();
    }
  });
}

export function errorAlert(message, hideAlert) {
  MySwal.fire({
    title: "Erro!",
    html: message,
    icon: 'error',
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn-danger "
    }
  }).then(hideAlert);
};


export function cleanFormatCNPJ(indentification) {
  let formated = indentification.replaceAll("-", "").replaceAll("/", "").replaceAll(".", "")
  return formated

}

export function cleanFormatCPF(indentification) {
  let formated = indentification.replaceAll("-", "").replaceAll(".", "")
  return formated

}

export function formatarCpfCnpj(valor) {
  if (valor != null) {
    const numeros = valor.replace(/\D/g, '');

    if (numeros.length === 11) {
      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    else if (numeros.length === 14) {
      return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    else {
      return valor;
    }
  } else {
    return valor
  }
}

export function formatarNumeroCNJ(valor) {
  const numeros = String(valor).replace(/\D/g, '');

  if (numeros.length !== 20) {
    return valor
  }

  return (
    numeros.slice(0, 7) + '-' +
    numeros.slice(7, 9) + '.' +
    numeros.slice(9, 13) + '.' +
    numeros.slice(13, 14) + '.' +
    numeros.slice(14, 16) + '.' +
    numeros.slice(16, 20)
  );
}

export function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers, 
     * and you may want to customize it to your needs
     */
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

export function verifyVariable(variable) {
  return variable !== null && variable !== 'null' && variable !== 'undefined' && variable !== undefined && variable !== '';
}


export function findElementByName(array, element) {
  var value = null;
  array.map(data => {
    if ((data.name).toUpperCase() === element.toUpperCase()) {
      value = data;
    }
    return null;
  });
  return value;
}

export function removeItem(arr, value) {
  var index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export function fromToValue(arr, value) {
  var valueFind = null;
  arr.map(data => {
    if (data.id === value) {
      valueFind = data;
    }
  })
  return valueFind;
}

export function fromToIdArray(arr, values) {
  let filtered = [];

  arr.map(data => {
    if (values.some(value => value === data.id)) {
      filtered.push(data)
    }
  })

  return filtered;
}


export function truncateText(string, value) {
  if (string.length > value)
    return string.substring(0, value) + "..."
  else
    return string
}


export function hideInfoCompany(arr, pageIndex) {
  if (pageIndex) {
    let i = pageIndex > 1 ? (5 * (pageIndex - 1)) + 1 : 1
    arr.forEach((data, index) => {
      data.participant.name = "Empresa " + (index + i);
      data.participant.identification = hideCompany("");
    });
  } else {
    arr.list.forEach((data, index) => {
      if (data.participantName != "OUTROS")
        data.participantName = "Empresa " + (index + 1);
    });
  }

  return arr;
}

export function hideNameCompany(arr, pageIndex) {

  let i = pageIndex > 1 ? (5 * (pageIndex - 1)) + 1 : 1
  arr.forEach((data, index) => {
    data.participant.name = "Empresa " + (index + i);
  });

  return arr;
}

export function hideCompany(value, isName) {
  if (isName)
    if (value != null)
      return value.substr(0, 1) + '*******************************'
    else return '*******************************'

  if (value != null) {
    // return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "***.***.***/****");
    return "***.***.***/****-**"
  } else return "000.000.000/0001"

}

export function hidePerson(value) {
  if (value != null) {
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
  } else return "000.000.000-01"

}

export function scrollToMarkdown(id) {
  var section = document.getElementById(id);
  section.scrollIntoView();
  section.focus();
}


export function handleApiLink(id) {
  var section = document.getElementById(id);
  section.scrollIntoView();
  var sectionButton = section.children[0].children[0];
  sectionButton.click();
}



/************** CHECKBOXTREE FUNCTIONS  ************** */

export function mountCheckboxTree(routes) {
  let nodes = [];
  routes.map(data => {
    if ((data.children).length > 0)
      nodes.push({ value: data.value, label: data.label, children: mountCheckboxTree(data.children) })
    else
      nodes.push({ value: data.value, label: data.label })
  })
  return nodes;
}




/**************************************************************************************** */

export function formatarParaMoeda(valor, moeda = 'BRL') {
  const opcoes = {
    style: 'currency',
    currency: moeda,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return new Intl.NumberFormat('pt-BR', opcoes).format(valor);
}

export function maskDdd(value) {
  let r = value ? String(value).replace(/\D/g, '') : '';
  if (r.length > 2) r = r.slice(0, 2);
  return r;
}

export function maskPhone(value) {
  let r = value ? String(value).replace(/\D/g, '') : '';
  if (r.length > 9) r = r.slice(0, 9);
  if (r.length === 9) {
    return r.replace(/^(\d{5})(\d{4})$/, '$1-$2');
  } else if (r.length > 4) {
    return r.replace(/^(\d{4})(\d{0,4})$/, '$1-$2');
  }
  return r;
}

export function maskPhoneWithDdd(value) {
  let r = value ? String(value).replace(/\D/g, '') : '';
  if (r.length > 11) r = r.slice(0, 11);
  if (r.length === 0) return '';
  if (r.length <= 2) return `(${r}`;
  if (r.length <= 6) return `(${r.slice(0, 2)}) ${r.slice(2)}`;
  if (r.length <= 10) return `(${r.slice(0, 2)}) ${r.slice(2, 6)}-${r.slice(6)}`;
  return `(${r.slice(0, 2)}) ${r.slice(2, 7)}-${r.slice(7)}`;
}

export function formatarTelefone(ddd, fone) {
  if (!fone && !ddd) return '';
  const dddClean = ddd ? String(ddd).replace(/\D/g, '').slice(0, 2) : '';
  let foneClean = fone ? String(fone).replace(/\D/g, '') : '';
  
  if (!dddClean && (foneClean.length === 10 || foneClean.length === 11)) {
    return maskPhoneWithDdd(foneClean);
  }
  
  if (foneClean.length > 9) foneClean = foneClean.slice(0, 9);
  let foneFmt = foneClean;
  if (foneClean.length === 9) {
    foneFmt = `${foneClean.slice(0, 5)}-${foneClean.slice(5)}`;
  } else if (foneClean.length === 8) {
    foneFmt = `${foneClean.slice(0, 4)}-${foneClean.slice(4)}`;
  }
  
  if (dddClean) {
    return `(${dddClean}) ${foneFmt}`;
  }
  return foneFmt;
}


